import Container from '@material-ui/core/Container';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';
import { AfterPageProps, wrapLayout } from '../../@sprinx/react-after-razzle';
import InfoLayout from '../../layouts/InfoLayout/InfoLayout';

export type NewsPageProps = AfterPageProps;
export type NewsPageClassNameKey = 'root';

const useStyles = makeStyles((theme: Theme) =>
  createStyles<NewsPageClassNameKey, {}>({
    root: {
      paddingTop: '150px',
      paddingBottom: '150px',
      [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(1),
      },
    },
  }),
);

const NewsPage: React.FC<NewsPageProps> = () => {
  const classes = useStyles();

  return (
    <>
      <Container>
        <div className={classes.root}>
          <h1>Aktuality</h1>

          <h2>Zde je místo pro aktuality</h2>
        </div>
      </Container>
    </>
  );
};

NewsPage.displayName = 'NewsPage';

export default wrapLayout(NewsPage, InfoLayout);
